import { useState } from "react";
import { useDispatch } from "react-redux";
import { COMMENT_MAX_LENGTH } from "utils/constants";
import { setAIHelperProgressRedux, clearAIHelperProgressRedux } from "redux/slices/aiHelperToolProgress/aiHelperProgressSlice";
import HeaderNav from "components/FutureNavBasedComponents/HeaderNav";
import UnderHeaderSection from "components/FutureNavBasedComponents/PageSubheader/UnderHeaderSection";
import PdfViewerMUI from "components/FutureNavBasedComponents/PdfViewer/PdfViewer";
import PillButton from "components/FutureNavBasedComponents/PillButton";
import TwoPanelView from "components/FutureNavBasedComponents/TwoPanelView";
import useAIHelperNavigation from "hooks/useAIHelperNavigation";
import useFormattedUserName from "./hooks/useFormattedUserName";
import { useSelector } from "react-redux";
import SkillPill from "components/SkillPill/SkillPill";
import educatorService from "services/educatorService";
import useCurrentLearnerId from "./hooks/useCurrentLearnerId";

const AIHelperShareFeedback = () => {
    const dispatch = useDispatch();
    const { handleBackToList, handleGoToSubskillsReview } = useAIHelperNavigation();
    const { firstName, userName } = useFormattedUserName();
    const artifactDetails = useSelector((state: any) => state.artifactDetails?.data);
    const aiHelperProgress = useSelector((state: any) => state.aiHelperProgress?.data);
    const areaTitles = aiHelperProgress.subskillsReview?.selectedAreasWithScoredCredits?.map((area: { title: any; }) => area.title) || [];
    const [comment, setComment] = useState(
        aiHelperProgress.shareFeedback?.summary || artifactDetails?.ai_summary?.summary ||  `Hi ${firstName},\n\nHere is some feedback on your artifact "${artifactDetails?.title}".\n\n[Insert personalized feedback based on the skills and subskills you reviewed. Be specific about what the learner did well and where they can improve.]\n\nKeep up the great work!\n`
    );
    const getCurrentLearnerId = useCurrentLearnerId(); 
    const learnerId = getCurrentLearnerId(); 

    const handleShareFeedback = async () => {
        try {
            if (comment.trim()) {
                const formData = new FormData();
                formData.append("learner_id", String(learnerId));
                formData.append("is_reviewed", String(true));

                await Promise.all([
                    educatorService.updateEvidence(artifactDetails?.id, formData),
                    educatorService.addComment(artifactDetails?.id, comment),
                ]);
            }
            clearAIHelperProgressRedux();
            handleBackToList();
        } catch (error) {
            console.error("Error sharing feedback:", error);
        }
    };

    return (
        <div className="max-h-dvh font-beausite text-typography-charcoal overflow-y-scroll">
            <div className="max-w-screen mx-[13px]">
                <HeaderNav />
            </div>

            <div className="flex justify-between">
                <UnderHeaderSection
                    backButtonLabel="Learner Artifacts List"
                    onBackButtonClick={() => { handleBackToList() }}
                    pageMainHeader="Draft & Share Feedback with Your Learner"
                />

                {/* <div className="flex items-center pr-[31px]">
          <PillButton onClick={() => {}} label="Get Started" variant="dark" />
        </div> */}
            </div>
            <TwoPanelView
                leftPanelSubheader={''}
                LeftPanelContent={
                    (
                        <>
                            <div className="mb-4">
                                <div className="mt-2 p-4 border border-[#A7ADB1] rounded-lg bg-white">
                                    <div className="text-sm font-normal mb-2">
                                        The primary skills you observed.
                                    </div>
                                    <SkillPill
                                        skills={areaTitles.length > 0 ? areaTitles : []} message="No skills were selected for this artifact."
                                    />
                                </div>
                            </div>
                             <div className="mb-4">
                                <div className="text-sm font-normal mt-[36px]">Draft actionable feedback for the learner.</div>
                                <div className="mt-2 border border-[#A7ADB1] rounded-lg overflow-hidden">
                                    <div className="p-4 bg-[rgba(245,245,245,1)]">
                                        <div className="text-base font-semibold">
                                            Learner Feedback
                                        </div>
                                        <div className="text-xs font-normal text-[#455459] mt-1">
                                            We have drafted some feedback for you to consider. Make any desired revisions in the text box. When you’re finished select <span className="font-semibold text-[#22333B]">Share Feedback.</span>
                                        </div>
                                    </div>
                                <hr className="border-[rgba(222, 225, 226, 1)]" />
                                    <textarea
                                        placeholder="Enter feedback here..."
                                        value={comment}
                                        onChange={(e) => {
                                            if (e.target.value.length <= COMMENT_MAX_LENGTH) {
                                                setComment(e.target.value)
                                                dispatch(setAIHelperProgressRedux({ ...aiHelperProgress, shareFeedback: { summary: e.target.value } }));
                                            }
                                        }}
                                        maxLength={COMMENT_MAX_LENGTH}
                                        className="w-full h-[120px] p-4 bg-white resize-none focus:outline-none"
                                    />
                                </div>
                                <div className="flex justify-end mt-1">
                                    <span className="text-xs text-[#455459]">{comment.length}/{COMMENT_MAX_LENGTH}</span>
                                </div>
                            </div>
                            <div className="flex items-center mt-6">
                                <PillButton variant="light" label="Back" onClick={() => { handleGoToSubskillsReview() }} outerDivClassName="mr-[14px]" />
                                <PillButton variant="dark" label="Share Feedback" onClick={handleShareFeedback} />
                            </div>
                        </>
                    )
                }
                rightPanelHeader={artifactDetails?.title}
                rightPanelSubheader={`Learner: ${userName}`}
                RightPanelContent={(<PdfViewerMUI file={artifactDetails?.fileUrl} />)}
            />
        </div>
    );
}

export default AIHelperShareFeedback;